import { render, staticRenderFns } from "./CabeceraModalSim.vue?vue&type=template&id=719eb592&scoped=true&"
import script from "./CabeceraModalSim.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalSim.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalSim.vue?vue&type=style&index=0&id=719eb592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719eb592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('719eb592', component.options)
    } else {
      api.reload('719eb592', component.options)
    }
    module.hot.accept("./CabeceraModalSim.vue?vue&type=template&id=719eb592&scoped=true&", function () {
      api.rerender('719eb592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/CabeceraModalSim.vue"
export default component.exports